'use client';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';

export default function StickyDeepResearchCta({
  href,
  className,
}: {
  href: string;
  className?: string;
}) {
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);
  const [centerX, setCenterX] = useState<number | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const rect = anchorRef.current?.getBoundingClientRect();
      if (!rect) {
        return;
      }
      setVisible(rect.top <= 16);
      setCenterX(rect.left + rect.width / 2);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <>
      <div ref={anchorRef} className={cn('h-px w-full', className)} />
      <div
        className={cn(
          'pointer-events-none fixed z-30 hidden px-4 transition-all duration-200 md:block',
          visible ? 'opacity-100' : 'opacity-0',
        )}
        style={{
          bottom: '24px',
          left: centerX ? `${centerX}px` : '50%',
          transform: 'translateX(-50%)',
        }}
      >
        <Button
          asChild
          variant="brand"
          className={cn(
            'pointer-events-auto h-11 items-center gap-2 rounded-full px-6 text-sm font-medium',
            'transition-transform duration-200',
            visible ? 'translate-y-0' : '-translate-y-2',
          )}
        >
          <Link href={href}>
            发起深度研究
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Button>
      </div>
    </>
  );
}
